import React from 'react'
import Xml from 'components/shared/Xml'
import { useSelector } from 'react-redux'
import selectIsLogged from 'redux/selectors/selectIsLogged'

const QaResultsItemExcerpt = ({ truncated, answer, xmlProps }) => {
  if (truncated) {
    return <hr /> // ?
  }

  const isLogged = useSelector(selectIsLogged)
  if (isLogged && answer) {
    return <Xml render={answer} {...xmlProps} />
  }

  return <div className='w-100 h3' />
}

export default QaResultsItemExcerpt
